import { render } from "./Logo.vue?vue&type=template&id=97cf4088&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=97cf4088&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cf4088"]])

export default __exports__